import { useEffect } from "react";
 
function useAutoResize(delay = 150) {
  useEffect(() => {
    let timeoutId;
  const calculateHeight = () => {
   
    const bodyRect = document.body.getBoundingClientRect();
    
    const height = Math.ceil(bodyRect.height);

   
 
    if (typeof height === 'number' && !isNaN(height)) {
        window.parent.postMessage({ type: 'resize', height }, '*');
        window.top.postMessage({ type: 'resize', height }, '*');
    }
};

    const sendHeightDebounced = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(calculateHeight, delay);
    };

    calculateHeight();

    window.addEventListener("resize", sendHeightDebounced);

    const observer = new MutationObserver(sendHeightDebounced);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    // Add a small delay to ensure initial content is rendered before first calculation
    setTimeout(calculateHeight, 500);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", sendHeightDebounced);
      observer.disconnect();
    };
  }, [delay]);
}
export default useAutoResize;